module.exports = __webpack_public_path__ + "img/jsw-sidebar.5c882c31.jpeg";